import React from 'react';
import brandCatalyTeaser from '../../../images/insight360/Bc-Teaser-Screen-2.png';
import { TEASER_EMAIL_CATALYST } from '../../../actions/urlTypes';

const BrandCatalystComingSoonTeaser = () => (
  <div className="sales-catalyst sc-coming-soon-panel">
    <div className="large-12 medium-12 small-12 columns heading1">
      {'Available Now!'}
    </div>
    <div className="large-12 medium-12 small-12 columns heading2" >
      {'Contact your representative or '}
      {<u><a href={`mailto:${TEASER_EMAIL_CATALYST}`}>{TEASER_EMAIL_CATALYST}</a></u>}
      {' for more Information.'}
    </div>
    <div className="large-12 medium-12 small-12 columns heading3">
      <div className="large-6 medium-6 small-6 columns heading3-left">
        <img src={brandCatalyTeaser} alt="spotify_weeble" />
      </div>
      <div className="large-6 medium-6 small-6 columns">
        <ul>
          <li><strong>Explore: </strong>
            Quickly discover what resonates with consumers of a defined
            brand. Gain deeper insights into the mindset and motivations of not
            only yours customers, but also that of the competition.
          </li>
          <li>
            <strong>Reporter: </strong>
            Analyze thousands of consumers attributes and quickly
            understand similarities and differences between the personas.
            Spend less time data mining and quickly discover stories and data points
            the inform marketing and advertising strategy.
          </li>
          <li>
            <strong>Creator: </strong>
            The creator feature automates the clustering of a persona into
            segments using underlying consumer psychographics, allowing marketers
            to test differentiated offering and messaging.
          </li>
        </ul>
      </div>
    </div>
  </div>
);

export default BrandCatalystComingSoonTeaser;
